import { getPropertyId } from './PropertiesUtils';
export default ((formFieldGroup, prefix = '') => (formFieldGroup.fields || []).reduce((acc, formField) => {
  /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  return acc.concat([getPropertyId(formField), formField.label]);
}, `${prefix}${formFieldGroup.richText ? `-${formFieldGroup.richText.content}` : ''}`));